var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"dbs_pr-common-loading-indicator",style:(_vm.loadingStyle)},[_c('div',{staticClass:"css3loader css3loader-3 dbs_pr-common-loading-indicator__loader"}),_vm._v("\n    "+_vm._s(_vm.loadingText)+"\n  ")]):_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60497001","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingIndicator.vue
// module id = null
// module chunks = 